// src/lib/layouts/fillerBulkControls.ts
// Bulk "apply to all" logic for the satisfatorio filler sequence's per-video
// maps (fillerFits / fillerPositions).

/** One entry per distinct playlist url, all set to `mode`. Replaces every
 *  per-item override; urls outside the playlist are dropped from the map. */
export function applyModeToAll<T extends string>(
  playlist: string[],
  mode: T,
): Record<string, T> {
  const map: Record<string, T> = {};
  for (const url of playlist) {
    if (url) map[url] = mode;
  }
  return map;
}

/** The effective value (map entry or `fallback`) shared by every playlist
 *  url, or null when the playlist is empty or the values are mixed. Drives
 *  the bulk buttons' highlight state. */
export function uniformValue<T extends string>(
  playlist: string[],
  map: Record<string, T> | undefined,
  fallback: T,
): T | null {
  if (playlist.length === 0) return null;
  const first = map?.[playlist[0]] ?? fallback;
  return playlist.every((url) => (map?.[url] ?? fallback) === first) ? first : null;
}
